define.alias("shared/components/shared/video-player/controls", "settings/components/shared/video-player/controls");